// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__3d0hg","innerWrapper":"footer_innerWrapper__3kc0u"};